"use client";

import CompanyInfo from "@/components/footer/CompanyInfo";
import Copyright from "@/components/footer/Copyright";
import QuickLinks from "@/components/footer/QuickLinks";
import { useGetContactInfo } from "@/hooks/main-hooks";
import { Mail, MapPin, Phone } from "lucide-react";
import { useLocale } from "next-intl";
import Partners from "./Partners";

export default function Footer() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const { data: contact } = useGetContactInfo();

  return (
    <footer
      dir={isAr ? "rtl" : "ltr"}
      className="relative overflow-hidden bg-brand-navy text-white pt-24 pb-12"
    >
      {/* Top Accent Line */}
      <div className="absolute top-0 left-0 w-full h-0.5 bg-linear-to-r from-transparent via-brand-red to-transparent opacity-70" />

      <div className="relative container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-14 mb-16">
          <div className="lg:col-span-5">
            <CompanyInfo locale={locale} />
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-3">
            <QuickLinks locale={locale} />
          </div>

          <div className="lg:col-span-4 space-y-8 flex justify-center">
            <div>
              <h3 className="text-xl font-semibold tracking-wide">
                {isAr ? "تواصل معنا" : "Contact Us"}
              </h3>

              <div className="space-y-5 text-sm text-gray-300 mt-6">
                <div className="flex items-center gap-3 hover:text-white transition">
                  <Mail className="w-5 h-5 text-brand-creamy shrink-0" />
                  <span>{contact?.email || "info@dawlia.com"}</span>
                </div>

                <div className="flex items-center gap-3 hover:text-white transition">
                  <Phone className="w-5 h-5 text-brand-creamy shrink-0" />
                  <span>{contact?.phone || "+20 100 000 0000"}</span>
                </div>

                <div className="flex items-center gap-3 hover:text-white transition">
                  <MapPin className="w-5 h-5 text-brand-creamy shrink-0" />
                  <span>
                    {isAr
                      ? contact?.addressAr || "القاهرة، مصر"
                      : contact?.addressEn || "Cairo, Egypt"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Partners />

        <Copyright locale={locale} />
      </div>
    </footer>
  );
}
